module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"title":"Добавить на полку","add":"Добавить","empty_shelves":"Полок нет","save":"Сохранить"}}')
  delete Component.options._Ctor
}
